import { AxiosResponse } from 'axios';
import type { AxiosInstance } from 'axios';
import { inject } from '@aesop-fables/containr';
import { ApiServices } from '../ApiServices';

export class OrgSelectionApi {
  constructor(@inject(ApiServices.Axios) private axios: AxiosInstance) {}

  select(organizationId: number): Promise<AxiosResponse<string>> {
    return this.axios.post(`org-selection/select/${organizationId}`);
  }

  unselect(): Promise<AxiosResponse<string>> {
    return this.axios.post('org-selection/unselect');
  }
}
